module.exports = __webpack_public_path__ + "static/media/green_pin.f3ac405b.svg";